import { MultiSelect, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns'
import { loadMessages, LocalizationProvider } from '@progress/kendo-react-intl'
import CustomText from 'components/text/CustomText'
import { useState } from 'react'
import styled from 'styled-components'
import { IDropdownOption, TDropdown } from 'types'
import trMessages from './shared-dd-tr'
import { useAppSelector } from 'app/hooks'
import enMessages from './shared-dd-en'
import arMessages from './shared-dd-ar'
loadMessages(trMessages, 'tr')
loadMessages(enMessages, 'en')
loadMessages(arMessages, 'ar')

interface IDropdownProps {
  id: string
  selectedOptions: IDropdownOption[]
  options: TDropdown
  onChangeOption: (params: IDropdownOption) => void
  className?: string
  title?: string
  disabled?: boolean
}

const DropdownMultiSelect = ({
  id,
  selectedOptions,
  options,
  onChangeOption,
  title,
  className,
  disabled,
}: IDropdownProps) => {
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState(options)

  const notificationLanguage =
    useAppSelector((state) => state.auth.user.notificationLanguage) || 'tr'

  const ontoggleOption = () => {
    if (!disabled) {
      setVisible((prevState) => !prevState)
    }
  }

  const handleFilterChange = (event: MultiSelectFilterChangeEvent) => {
    const searchText = event.filter.value.toLowerCase()

    const filteredData = options.filter((item) => item.title.toLowerCase().includes(searchText))
    setData(filteredData)
  }

  return (
    <>
      <LocalizationProvider
        language={`${notificationLanguage}-${notificationLanguage?.toUpperCase()}`}
      >
        <DrowdownContainer className={className} onClick={ontoggleOption}>
          {title && (
            <TitleWrapper>
              <CustomText typography="header3">{title}</CustomText>
            </TitleWrapper>
          )}
          <MultiSelect
            id={id}
            data={data}
            textField="title"
            dataItemKey="value"
            filterable={true}
            onFilterChange={handleFilterChange}
            value={selectedOptions}
            onChange={(e) => onChangeOption(e.value)}
          />
        </DrowdownContainer>
        {visible && <BackDrop />}
      </LocalizationProvider>
    </>
  )
}

export default DropdownMultiSelect

const BackDrop = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
  pointer-events: none;
`

const DrowdownContainer = styled.div`
  margin-top: 5px;
  gap: 3px;
  position: relative;
  z-index: 4;
`

const TitleWrapper = styled.div`
  gap: 3px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 8px;
`
